export const NOT_FOUND_SALE_MESSAGE = "Not finished sale not found";
export const AVATAR_TYPE_ERROR = "Image format is invalid. Please select JPG, JPEG or PNG file";
export const AVATAR_MAX_SIZE_ERROR = "Maximum image size is 30Mb";
